// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__URYhy","show":"Header_show__8Hkfv"};